import { render, staticRenderFns } from "./Elemento.vue?vue&type=template&id=42b0fd53&"
import script from "./Elemento.vue?vue&type=script&lang=js&"
export * from "./Elemento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports